module.exports = __webpack_public_path__ + "static/img/icon-event.4cc0499a.png";